var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alerts-list" },
    _vm._l(_vm.alerts, function (message, index) {
      return message.show
        ? _c(
            "div",
            {
              staticClass: "alert alert-dismissible fade show",
              class: "alert-" + message.type,
              attrs: { role: "alert" },
            },
            [
              message.title
                ? _c("strong", [_vm._v(_vm._s(message.title))])
                : _vm._e(),
              _vm._v(" "),
              _c("p", { domProps: { innerHTML: _vm._s(message.message) } }),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "alert",
                  "aria-label": "Close",
                },
                on: {
                  click: function ($event) {
                    return _vm.close(message, index)
                  },
                },
              }),
              _vm._v(" "),
              message.critical
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.notify(message, index)
                        },
                      },
                    },
                    [_vm._v("\n            send error notification\n        ")]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }